export const SERP_LEAD_BANNER_TEXTS = {
  title: 'Подбираете отель? Наши сотрудники помогут найти лучший вариант',
  subtitle: 'Наши сотрудники помогут найти лучший вариант',
  button: 'Подберите мне отель',
} as const;

export const SERP_LEARN_DISCOUNT_BANNER_TEXTS = {
  title: 'Скидка 500 ₽ на первый тур',
  subtitle: 'Установите приложение и получите её\u00A0на первую покупку',
  download: 'Скачать из',
} as const;

export const SERP_HACKS8_BANNER_TEXTS = {
  title: '8 лайфхаков для выбора отеля',
  description: 'Оставьте email, и мы пришлём памятку с\u00A0советами по выбору лучших отелей',
  placeholder: 'Введите ваш email',
  submit: 'Получить',
  consent: 'Я даю согласие на получение рекламных сообщений',
  successTitle: 'Спасибо! Лайфхаки уже у вас на почте',
  emailRequired: 'Обязательное поле',
  emailInvalid: 'Введите правильный email',
  errorTitle: 'Что-то пошло не так',
  errorDescription: 'Не удалось отправить памятку. Попробуйте ещё раз.',
} as const;

export const SERP_DREAM_TOUR_BANNER_TEXTS = {
  title: 'Ваш тур мечты',
  subtitle: 'Беспроигрышная акция — каждому участнику скидка',
  action: 'Выиграйте тур за',
  rubleForms: ['рубль', 'рубля', 'рублей'],
} as const;

export const SERP_SUBSCRIBE_BANNER_TEXTS = {
  title: 'Подписывайтесь, чтобы не пропустить выгодные туры!',
} as const;

export const SERP_APP_INSTALL_BANNER_TEXTS = {
  title: 'узнайте о снижении цены на туры!',
  fallbackTitle: 'Узнайте о снижении цены на туры!',
  subtitle: 'Добавьте направление в Турхантер через приложение, и мы сообщим вам, когда цена на туры снизится',
  install: 'Установить приложение',
} as const;

export const SERP_GIFT_CERTIFICATES_BANNER_TEXTS = {
  title: 'Этот подарок точно понравится',
  subtitle: 'Сертификат на отдых — когда хочется подарить что-то по-настоящему важное',
  button: 'Выбрать сертификат',
} as const;
